/**
 * Lookbook Mosaic Layout
 * Replaces the carousel functionality with a static mosaic grid
 */

(function() {
  'use strict';

  const htmlElement = document.querySelector('html');
  const coverElement = document.getElementById('lookbook-single__cover');
  const mosaicContainer = document.querySelector('.lookbook-single__mosaic');

  if (!mosaicContainer) return;

  // Handle cover animation
  if (coverElement && htmlElement) {
    htmlElement.classList.add('lookbook-cover-active');
      
    setTimeout(function() {
      coverElement.classList.add('hide');
      mosaicContainer.classList.remove('hide');
      htmlElement.classList.remove('lookbook-cover-active');
    }, 500);
  }
})();
